import React from 'react';

const Tutorial = ({ currentStep, onNext, onSkip, isActive }) => {
  if (!isActive) return null;

  const steps = [
    {
      target: '.score-circle',
      title: '🎯 Nearness to God Index',
      description: 'This is your NGI Score. It grows as you log spiritual habits daily. Track your spiritual journey!',
      position: 'bottom'
    },
    {
      target: 'input[type="date"]',
      title: '📅 Log Past Dates',
      description: 'Missed logging yesterday? Change the date here to backfill your habits.',
      position: 'bottom'
    },
    {
      target: '.habits-grid',
      title: '✨ Log Your Habits',
      description: 'Click any of the 12 spiritual pillars to log them. Click again to uncheck. Build your daily routine!',
      position: 'top'
    },
    {
      target: '.stats-row',
      title: '🔥 Track Your Progress',
      description: 'See your day streak and completion percentage. Consistency is key to spiritual growth!',
      position: 'top'
    },
    {
      target: '.quick-nav',
      title: '🧭 Navigation',
      description: 'Three main sections: Prayers (journal), Bible (search & bookmark verses), Profile (badges & achievements)',
      position: 'top'
    },
    {
      target: '.quick-nav button:nth-child(1)',
      title: '🙏 Prayer Journal',
      description: 'Write prayers, track your mood, add tags. See all your prayers in one place!',
      position: 'top'
    },
    {
      target: '.quick-nav button:nth-child(2)',
      title: '📖 Bible Reader',
      description: 'Search Bible verses (Genesis 1:1, John 3:16). Bookmark your favorite verses!',
      position: 'top'
    },
    {
      target: '.quick-nav button:nth-child(3)',
      title: '👤 Profile & Badges',
      description: 'See all badges you have earned. View requirements for badges you can still unlock!',
      position: 'top'
    },
    {
      target: '.app-header',
      title: '✅ Ready to Begin!',
      description: 'You are all set! Start logging your spiritual habits today. Tap Skip anytime to close this guide.',
      position: 'bottom'
    }
  ];

  const step = steps[currentStep];
  if (!step) return null;

  return (
    <>
      <div className="tutorial-overlay" onClick={onSkip} />
      <TutorialSpotlight step={step} stepNumber={currentStep + 1} totalSteps={steps.length} onNext={onNext} onSkip={onSkip} />
    </>
  );
};

const TutorialSpotlight = ({ step, stepNumber, totalSteps, onNext, onSkip }) => {
  const targetElement = document.querySelector(step.target);
  
  if (!targetElement) return null;

  const rect = targetElement.getBoundingClientRect();
  const padding = 12;

  const spotlightStyle = {
    position: 'fixed',
    top: rect.top - padding,
    left: rect.left - padding,
    width: rect.width + padding * 2,
    height: rect.height + padding * 2,
    boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.7)',
    borderRadius: '12px',
    pointerEvents: 'none',
    zIndex: 9998,
    animation: 'tutorialPulse 2s infinite'
  };

  const tooltipStyle = {
    position: 'fixed',
    zIndex: 9999,
    background: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
    maxWidth: '320px',
    animation: 'tutorialFadeIn 0.3s ease'
  };

  let tooltipTop, tooltipLeft;
  
  if (step.position === 'bottom') {
    tooltipTop = rect.bottom + 20;
    tooltipLeft = Math.max(20, Math.min(rect.left, window.innerWidth - 340));
  } else {
    tooltipTop = rect.top - 220;
    tooltipLeft = Math.max(20, Math.min(rect.left, window.innerWidth - 340));
  }

  tooltipStyle.top = tooltipTop;
  tooltipStyle.left = tooltipLeft;

  return (
    <>
      <div style={spotlightStyle} />
      <div style={tooltipStyle}>
        <h3 style={{ margin: '0 0 8px 0', color: '#00BFD9', fontSize: '16px', fontWeight: '700' }}>
          {step.title}
        </h3>
        <p style={{ margin: '0 0 16px 0', color: '#004D5C', fontSize: '13px', lineHeight: '1.5' }}>
          {step.description}
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '12px', color: '#00768F', fontWeight: '600' }}>
            {stepNumber} / {totalSteps}
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={onSkip}
              style={{
                padding: '8px 14px',
                background: 'rgba(0, 189, 217, 0.1)',
                border: '2px solid #00BFD9',
                color: '#00BFD9',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '12px'
              }}
            >
              Skip
            </button>
            <button
              onClick={onNext}
              style={{
                padding: '8px 14px',
                background: 'linear-gradient(135deg, #00BFD9, #00E5FF)',
                border: 'none',
                color: 'white',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: '700',
                fontSize: '12px'
              }}
            >
              {stepNumber === totalSteps ? 'Done' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tutorial;
